import { Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PrinterService } from '../../_services/fundraising/printer.service';
import { BarrelPrinter } from '../../_models/fundraising/BarrelPrinter';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from '../../_services/dialog.service';
import { Cue5050Service } from '../../_services/fundraising/cue5050.service';
import { Cue5050 } from '../../_models/fundraising/Cue5050';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-printer-create',
    templateUrl: './printer-create.component.html',
    styleUrls: ['./printer-create.component.css']
})

export class PrinterCreateComponent implements OnInit  {

    public form: FormGroup;

    public printerId: number;
    public printer: BarrelPrinter;

    public events: Cue5050[] = [];

    constructor(
        private printerService: PrinterService,
        private route: ActivatedRoute,
        private router: Router,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private viewRef: ViewContainerRef,
        private fb: FormBuilder,
        private cue5050Service: Cue5050Service
    ) { }

    ngOnInit(): void {
        this.spinner.show();

        this.route.params
        .subscribe(params => {
            this.printerId = params['id'] ?? 0;
            const printerObs = this.printerService.getById(this.printerId);
            const eventObs = this.cue5050Service.getAll();

            forkJoin([printerObs, eventObs])
                .subscribe(data => {
                    this.printer = data[0];
                    this.events = data[1].cue5050s.filter(q => q.event.status < 3);

                    this.createForm(this.printer);                  
                    this.spinner.hide();

                },
                error => {
                    this.dialogService.alert("Oops something went wrong...", error.error, this.viewRef);
                    this.spinner.hide();             
                }
            )
        });
    }

    createForm(printer: BarrelPrinter) {
        this.form = this.fb.group({
            barrelPrinterId: [printer?.barrelPrinterId || 0, Validators.required],
            name: [printer?.name, [Validators.required, Validators.maxLength(30)]],
            vendorId: [printer?.vendorId || 0, Validators.required],
            cue5050Id: [printer?.cue5050Id || 0, Validators.required]
        });

    }

    hasErrors() {
        return this.form && !this.form.valid && this.form.touched;
    }

    save() {

        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        if (this.hasErrors()) {
          this.form.markAllAsTouched();
          this.form.markAsDirty();

          return;
        }

        this.spinner.show();

        const printerData = new BarrelPrinter(this.form.getRawValue());

        if(this.printerId > 0) {
            this.printerService.update(printerData).subscribe(
              () => { 
                this.spinner.hide();
                this.navigateUp();
              },
              error => {
                this.spinner.hide();
                this.dialogService.error(error, 'Unable to update printer', this.viewRef);
              }
            );
          } else {
            this.printerService.create(printerData).subscribe(
              () => { 
                this.spinner.hide();
                this.navigateUp();
              },
              error => {
                this.spinner.hide();
                this.dialogService.error(error, 'Unable to create printer', this.viewRef);
              }
            );
          }

    }

    public  navigateUp() {
        this.router.navigate([this.printerId > 0 ? '../../' : '../'], {relativeTo: this.route});
      }


}